import React from 'react'
import { connect } from 'react-redux'
import SoundPage from './sound'
import DebugPage from './debug'
import Cheats from './cheats'
import Hotzones from './debug/hotzones'
import { setGamespeed } from '../redux/actions'
import SpeedMeter from './speedMeter/speedMeter'

const gameSpeedIntervals = [ 0, 0.01, 0.33, 0.66, 1, 2, 3 ]
const DefaultTools = [
  { title: 'Sounds', component: SoundPage },
  { title: 'Debug', component: DebugPage },
  { title: 'Cheats', component: Cheats }
]

/**
 * Container for the "developerMode options"
 */
@connect(state => ({
  gamespeed: state.base.gamespeed,
  hideFPSmeter: state.base.hideFPSmeter,
  menuOpacity: state.base.menuOpacity,
}), {
  setGamespeed
})
export default class Dev extends React.Component {
  state = {
    portrait: false,
    isConsoleOpen: false,
    selectedComponent: false,
  }

  componentDidMount() {
    window.addEventListener('keydown', this.gameSpeedHotkey)
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.gameSpeedHotkey)
  }

  
  gameSpeedHotkey = (e) => {
    switch (e.code) {
      case 'NumpadSubtract': {
        this.slowDownGame()
        break
      }
      case 'NumpadAdd': {
        this.speedUpGame()
        break
      }
    }
  }

  slowDownGame = () => {
    const currentSpeed = this.props.gamespeed
    if (currentSpeed > 0) {
      let index = 0
      let newIndex = 0
      for (; index < gameSpeedIntervals.length; index++) {
        if (gameSpeedIntervals[index] >= currentSpeed) {
          newIndex = Math.max(index - 1, 0)
          break
        }
      }
      this.props.setGamespeed(gameSpeedIntervals[newIndex])
    }
  }

  speedUpGame = () => {
    const currentSpeed = this.props.gamespeed
    if (currentSpeed < 3) {
      let index = 0
      for (; index < gameSpeedIntervals.length; index++) {
        if (gameSpeedIntervals[index] > currentSpeed) {
          break
        }
      }
      this.props.setGamespeed(gameSpeedIntervals[index])
    }
  }

  /**
   * Toggles the DevTool settings open/closed.
   */
  toggleConsole = () => {
    this.setState({ isConsoleOpen: !this.state.isConsoleOpen })
  }
  toggleComponent(selectedComponent) {
    this.setState({ selectedComponent: (selectedComponent === this.state.selectedComponent) ? false : selectedComponent })
  }

  render() {
    const { Components, hasConfigurableVariables, menuOpacity } = this.props
    const { isConsoleOpen } = this.state
    const buttonValue = !isConsoleOpen ? 'Open Console' : 'Close Console'
    const componentTools = []

    Object.values(Components).filter(c => c.devTools).forEach(comp => {
      if (comp.devTools.length > 0) {
        comp.devTools.forEach(tool => {
          componentTools.push({ title: tool.title || tool.displayName, component: tool })
        })
      } else {
        componentTools.push({ title: comp.devTools.title || comp.devTools.displayName, component: comp.devTools })
      }
    })

    const AllTools = [ ...componentTools, ...DefaultTools ]
    const tabs = AllTools.map(c => <a key={c.title} className={`tabTitle ${this.state.selectedComponent === c.title ? ' active' : ''}`} onClick={() => this.toggleComponent(c.title)}>{c.title}</a>)

    return (
      <div id="devConsoleWrapper" style={{ opacity: menuOpacity }}>
        { isConsoleOpen && (
          <div id="devConsole" style={{ display: 'block' }}>
            {tabs}
            {AllTools.filter(c => c.title === this.state.selectedComponent).map(c => <c.component key={`c_${c.title}`} hasConfigurableVariables={hasConfigurableVariables} />)}
          </div>
        )}
        <Hotzones />
        <input id="devConsoleButton" type="button" value={buttonValue} onClick={this.toggleConsole} />
        <SpeedMeter value={this.props.gamespeed} fpsEnabled={!this.props.hideFPSmeter} />
      </div>
    )
  }
}
